import { format, parse } from "date-fns";
import {
  Autocomplete,
  DatePicker,
  DesktopTimePicker,
  Grid,
  IconButton,
  LocalizationProvider,
  MaskedInput,
  MenuItem,
  Select,
  TextField,
} from "../../../components";
import { value } from "../../../helpers";
import { formatDate } from "../../../utils";

const AgendamentoServicoForm = ({
  agendamento,
  setAgendamento,
  configuracoes,
  clienteList,
  servicoList,
  prestadorServicoList,
  horariosList,
  handleChangeTextfield,
  onChangeDate,
  onChangePrestador,
}) => {
  const handleChangeHora = (time) => {
    if (!time || !agendamento?.data) return;
    const date = new Date(agendamento.data);
    date.setHours(time.getHours());
    date.setMinutes(time.getMinutes());
    date.setSeconds(0);
    date.setMilliseconds(0);
    setAgendamento((prev) => ({
      ...prev,
      periodo: date != "Invalid Date" ? date.toISOString() : null,
    }));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          id="clienteId"
          name="clienteId"
          options={clienteList}
          autoHighlight
          getOptionLabel={(option) => option.clienteNome}
          loadingText="Carregando"
          renderInput={(params) => (
            <TextField
              {...params}
              label={"Cliente"}
              variant="filled"
              disabled
            />
          )}
          value={value.autoComplete(clienteList, agendamento?.clienteId)}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          id="servicoId"
          name="servicoId"
          options={servicoList}
          autoHighlight
          getOptionLabel={(option) => option.servicoNome}
          value={value.autoComplete(servicoList, agendamento?.servicoId)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={"Buscar Serviço"}
              variant={"filled"}
              disabled
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          id="prestadorServicoId"
          name="prestadorServicoId"
          options={prestadorServicoList}
          autoHighlight
          getOptionLabel={(option) => {
            let codigoPessoa = option?.codigo ? `${option.codigo} - ` : "";
            let descricaoPessoa = codigoPessoa + `${option.nomeRazaoSocial}`;
            return option ? descricaoPessoa : "";
          }}
          noOptionsText={
            <Grid container spacing={1}>
              <Grid item xs={12} fullWidth>
                Nenhum prestador encontrado
              </Grid>
            </Grid>
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={"Buscar Prestador de Serviço"}
              variant={"outlined"}
            />
          )}
          onChange={(_, newValue) => onChangePrestador(newValue)}
          value={value.autoComplete(
            prestadorServicoList,
            agendamento?.prestadorServicoId,
          )}
        />
      </Grid>
      <Grid item xs={5}>
        <MaskedInput
          id="celular"
          label="Celular"
          name="celular"
          margin="none"
          mask="(99) 9 9999-9999"
          InputLabelProps={{ shrink: true }}
          onChange={handleChangeTextfield}
          value={agendamento?.celular ?? ""}
          InputProps={{
            endAdornment: (
              <IconButton disabled>
                <i
                  className="ph-fill ph-device-mobile"
                  style={{
                    color: "#494C62",
                    fontSize: 20,
                  }}
                ></i>
              </IconButton>
            ),
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <DatePicker
          id="data"
          name="data"
          label="Data"
          format="dd/MM/yyyy"
          minDate={new Date()}
          value={value.date(agendamento?.data)}
          onChange={(date) => onChangeDate("data", date)}
        />
      </Grid>
      <Grid item xs={3}>
        {configuracoes.intervaloAgendamentos ? (
          <Select
            id="hora"
            name="hora"
            value={
              agendamento?.periodo
                ? format(new Date(agendamento?.periodo), "HH:mm")
                : ""
            }
            label="Hora"
            fullWidth
            disabled={!horariosList.length}
            disableClearable
            onChange={(e) => {
              const horaFormatada = parse(e.target.value, "HH:mm", new Date());
              handleChangeHora(horaFormatada);
            }}
          >
            {horariosList.map((horario, index) => (
              <MenuItem key={`${horario}-${index}`} value={horario}>
                {horario}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <LocalizationProvider>
            <DesktopTimePicker
              sx={{ width: "100%" }}
              name="hora"
              label="Hora"
              disabled={!agendamento?.data}
              onChange={handleChangeHora}
              value={
                agendamento?.periodo
                  ? formatDate.received(agendamento?.periodo)
                  : null
              }
            />
          </LocalizationProvider>
        )}
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="observacao"
          name="observacao"
          label="Observação"
          variant="outlined"
          value={agendamento?.observacao ?? ""}
          onChange={handleChangeTextfield}
          InputProps={{ inputProps: { maxLength: 50 } }}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
    </Grid>
  );
};

export default AgendamentoServicoForm;
